import { RecordsGrid } from '../RecordPropertyRolePanel/RecordsGrid';
import { RolePanel } from '../rolePanel';
import { PanelData } from '../RolePanelTypes';
import { GridViewRolesGrid } from './GridViewRolesGrid';

export class GridViewRolePanel {
    gridViewRolePanelEl: HTMLElement;
    
    private rolePanel: RolePanel;
    private recordsGrid: RecordsGrid;
    gridViewRolesGrid: GridViewRolesGrid;

    constructor(rolePanel: RolePanel) {
        this.rolePanel = rolePanel;        
    }

    destroy() {
        this.recordsGrid.api.destroy();
        if (this.gridViewRolesGrid.api !== null) {
            this.gridViewRolesGrid.api.destroy();        
            
        }
    }
    getSelectedRecordName() {
        return this.recordsGrid.api.getSelectedRows()[0].Name;        
    }
    private handleRecordSelectionChange() {
        this.gridViewRolesGrid.reload(`/${this.getSelectedRecordName()}/${this.rolePanel.getSelectedRole().Id}`, this.rolePanel.panelData)
    }
    async init(roleId: string, panelData: PanelData) {

        this.gridViewRolePanelEl = document.createElement('div');
        this.gridViewRolePanelEl.classList.add('gridViewRolePanel');

        await this.initRecordsGrid();
        await this.initGridViewRolesGrid(this.recordsGrid.api.getSelectedRows()[0].Name, roleId, panelData);

        this.recordsGrid.api.addEventListener('selectionChanged', this.handleRecordSelectionChange.bind(this));
    }
    private async initRecordsGrid(): Promise<void>{
        this.recordsGrid = new RecordsGrid();
        await this.recordsGrid.init();
        this.gridViewRolePanelEl.appendChild(this.recordsGrid.gridContainer);
    }
    private async initGridViewRolesGrid(recordName: string, roleId: string, panelData: PanelData) {
        this.gridViewRolesGrid = new GridViewRolesGrid();
        await this.gridViewRolesGrid.initOrReload(`/${recordName}/${roleId}`, panelData);

        this.gridViewRolePanelEl.appendChild(this.gridViewRolesGrid.gridContainer);
    }
}
    
    